import type { OrderDraft } from "./cartTypes";

export const ORDER_DRAFT_STORAGE_KEY = "currentOrderCartDraft";

export const PAYMENT_METHODS = [
  // { label: "Наличными в магазине", value: "cash_store" },
  // { label: "Картой в магазине", value: "card_store" },
  { label: "Безналичный расчёт", value: "bank_transfer" },
  // { label: "Уточнить позже", value: "later" },
] as const;

export const INITIAL_ORDER_DRAFT: OrderDraft = {
  orderId: "",
  phone: "",
  email: "",
  fullName: "",
  paymentMethod: PAYMENT_METHODS[0].value,
  promoCode: "",
  addressCommentInn: "",
  orderName: "",
};
